module.exports = __webpack_public_path__ + "img/selections-4.webp";